export default "__VITE_ASSET__COd2$7xb__"